<div class="complete-status-description-modal">
  <div
    (click)="closeModal()"
    (keydown.enter)="closeModal()"
    class="complete-status-description-modal__close"
    tabindex="0"
  >
    <ui-svg-icon
      iconClassName="preview-modal--close"
      svgId="close"
    ></ui-svg-icon>
  </div>
  <h1 class="complete-status-description-modal__title">
    <div class="complete-status-description-modal__title__icon">
      <ui-svg-icon svgId="info-filled"></ui-svg-icon>
    </div>
    <div>Status key indicator{{ multipleKeyIndicatorsEnabled ? 's' : '' }}</div>
  </h1>
  <div class="complete-status-description-modal__content">
    <div
      *ngIf="statusDescriptionEnabledConfig.dueNow"
      class="complete-status-description-modal__content__info"
    >
      <div
        class="complete-status-description-modal__content__info__header due-now"
      >
        <div
          class="complete-status-description-modal__content__info__header__icon"
        >
          <ui-svg-icon class="svg" svgId="alert"></ui-svg-icon>
        </div>
        <div>Due Now</div>
      </div>
      <div
        class="complete-status-description-modal__content__info__description"
      >
        Update this item immediately to remain eligible to work.
      </div>
    </div>
    <div
      *ngIf="statusDescriptionEnabledConfig.inReview"
      class="complete-status-description-modal__content__info"
    >
      <div
        class="complete-status-description-modal__content__info__header in-review"
      >
        <div
          class="complete-status-description-modal__content__info__header__icon"
        >
          <ui-svg-icon class="svg" svgId="magnifying-glass"></ui-svg-icon>
        </div>
        <div>In Review</div>
      </div>
      <div
        class="complete-status-description-modal__content__info__description"
      >
        We’re reviewing your changes. Check back soon for updates.
      </div>
    </div>
    <div
      *ngIf="statusDescriptionEnabledConfig.updateSoon"
      class="complete-status-description-modal__content__info"
    >
      <div
        class="complete-status-description-modal__content__info__header update-soon"
      >
        <div
          class="complete-status-description-modal__content__info__header__icon"
        >
          <ui-svg-icon class="svg" svgId="alarm-clock"></ui-svg-icon>
        </div>
        <div>Update Soon</div>
      </div>
      <div
        class="complete-status-description-modal__content__info__description"
      >
        Update this item soon to minimise interruptions to your work.
      </div>
    </div>
    <div
      *ngIf="statusDescriptionEnabledConfig.upToDate"
      class="complete-status-description-modal__content__info"
    >
      <div
        class="complete-status-description-modal__content__info__header up-to-date"
      >
        <div
          class="complete-status-description-modal__content__info__header__icon"
        >
          <ui-svg-icon class="svg" svgId="thumb-up"></ui-svg-icon>
        </div>
        <div>Up To Date</div>
      </div>
      <div
        class="complete-status-description-modal__content__info__description"
      >
        This item is valid – no actions required. You can still make updates or
        changes as required.
      </div>
    </div>
    <div
      *ngIf="statusDescriptionEnabledConfig.rejected"
      class="complete-status-description-modal__content__info"
    >
      <div
        class="complete-status-description-modal__content__info__header rejected"
      >
        <div
          class="complete-status-description-modal__content__info__header__icon"
        >
          <ui-svg-icon class="svg" svgId="cross-hollow"></ui-svg-icon>
        </div>
        <div>Rejected</div>
      </div>
      <div
        class="complete-status-description-modal__content__info__description"
      >
        Documentation provided does not meet our compliance criteria. Please
        provide alternative or updated documentation.
      </div>
    </div>
  </div>
  <div class="complete-status-description-modal__actions">
    <div class="complete-status-description-modal__actions__button">
      <ui-button
        (handleClick)="closeModal()"
        [isSecondary]="true"
        buttonClassName="button-full-width"
        buttonId="complete-status-description-modal-close"
        buttonText="Close"
        gtmTag="complete-status-description-modal-close"
      ></ui-button>
    </div>
  </div>
</div>
